import React from 'react';
import ForecastContainer from '../Containers/ForecastContainer';

const Forecast = (props) => {
	return (
		<ForecastContainer />
	);
}
export default Forecast;